/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

/**
 * Possible values for the grid page sizes. This is in
 * use when pagination is enabled
 */
export const PAGE_SIZES = [20, 50, 100];
